var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestination1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_12142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_427_12142",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.716 0 0 6.716 0 15C0 23.283 6.716 30 15 30C23.285 30 30 23.283 30 15C30 6.716 23.285 0 15 0Z",
    fill: "#F58B7F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_427_12142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.716 0 0 6.716 0 15C0 23.283 6.716 30 15 30C23.285 30 30 23.283 30 15C30 6.716 23.285 0 15 0Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7C10.5819 7 7 10.5819 7 15C7 19.4176 10.5819 23 15 23C19.4187 23 23 19.4176 23 15C23 10.5819 19.4187 7 15 7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11C12.7909 11 11 12.7909 11 15C11 17.2088 12.7909 19 15 19C17.2093 19 19 17.2088 19 15C19 12.7909 17.2093 11 15 11Z",
    fill: "#0270B2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_12142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination1);
export default __webpack_public_path__ + "static/media/destination1.51aade7044a18592732ab5a1fc8e513d.svg";
export { ForwardRef as ReactComponent };